import * as MT from '../mutation-types'

export const moneyStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      allSponsoren: 'sponsoren/all',
      saveSponsor: 'sponsoren/save',
      userFinanzen: 'finanzen/all',
      saveSparbetrag: 'finanzen/saveSparbetrag'
    },
    giro: 0,
    spar: {},
    sponsor: 0,
    sponsoren: [],
    saison: {},
    lifetime: {},
    cacheTime: 0 // in sec
  },
  mutations: {
    [MT.MONEY_RESET] (state) {
      state.giro = 0
      state.spar = 0
      state.sponsor = 0
      state.sponsoren = []
      state.saison = {}
      state.lifetime = {}
      state.cacheTime = 0
    },
    [MT.MONEY_SET_ALL_SPONSOREN] (state, sponsorenList) {
      state.sponsoren = sponsorenList
    },
    [MT.MONEY_SET_SPONSOR] (state, sponsor) {
      state.sponsor = sponsor
    },
    [MT.MONEY_SET_GIRO] (state, data) {
      state.giro = data
    },
    [MT.MONEY_SET_SPAR] (state, data) {
      state.spar = data
    },
    [MT.MONEY_SET_FINANZEN] (state, finanzData) {
      state.giro = finanzData.giro || 0
      state.spar = finanzData.spar || 0
      state.saison = finanzData.saison
      state.lifetime = finanzData.lifetime
    }
  },
  getters: {
    allMoney: (state) => {
      return state.giro
    },
    allSponsorenUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.allSponsoren
    },
    saveSponsorURL: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveSponsor
    },
    usersFinanzenURL: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.userFinanzen
    },
    saveSparbetrag: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveSparbetrag
    },
    getSponsorDayMoney: (state) => {
      return state.sponsor.spieltag
    },
    getSaisonEinnahmen: (state) => {
      let sponsorEinnahmen = 0
      let zinsenEinnahmen = 0

      if (state.saison.einnahmen) {
        // sponsor
        sponsorEinnahmen = state.saison.einnahmen.sponsor || 0
        // zinsen
        zinsenEinnahmen = state.saison.einnahmen.zinsen || 0
      }

      return [
        { item: 'Sponsor', value: sponsorEinnahmen },
        { item: 'Zinsen', value: zinsenEinnahmen }
      ]
    },
    getSaisonAusgaben: (state) => {
      const saisonAusgaben = state.saison.ausgaben

      let kegelbahnrepair = 0
      let kegelbahnkauf = 0
      let fahrzeugrepair = 0
      let fahrzeugkauf = 0
      let trainingslager = 0
      let spielergehaelter = 0
      let spielerkaeufe = 0

      if (saisonAusgaben) {
        // kegelabhn
        if (saisonAusgaben.kegelbahn) {
          kegelbahnrepair = saisonAusgaben.kegelbahn.repair || 0
          kegelbahnkauf = saisonAusgaben.kegelbahn.buy || 0
        }
        // fahrzeug
        if (saisonAusgaben.fahrzeug) {
          fahrzeugrepair = saisonAusgaben.fahrzeug.repair || 0
          fahrzeugkauf = saisonAusgaben.fahrzeug.buy || 0
        }
        // trainingslager
        trainingslager = saisonAusgaben.trainingslager || 0
        // spielergehaelter
        spielergehaelter = saisonAusgaben.spielergehaelter || 0
        // spielerkaeufe
        if (saisonAusgaben.player) {
          spielerkaeufe = saisonAusgaben.player.buy || 0
        }
      }

      return [
        { item: 'Spielergehälter', value: spielergehaelter },
        { item: 'Spielereinkäufe', value: spielerkaeufe },
        { item: 'Kegelbahnreparatur', value: kegelbahnrepair },
        { item: 'Kegelbahnkäufe', value: kegelbahnkauf },
        { item: 'Fahrzeugreparatur', value: fahrzeugrepair },
        { item: 'Fahrzeugkäufe', value: fahrzeugkauf },
        { item: 'Trainingslager', value: trainingslager }
      ]
    },
    getLifetimeEinnahmen: (state) => {
      let sponsorEinnahmen = 0
      let zinsenEinnahmen = 0
      if (state.lifetime.einnahmen) {
        // sponsor
        sponsorEinnahmen = state.lifetime.einnahmen.sponsor || 0
        // zinsen
        zinsenEinnahmen = state.lifetime.einnahmen.zinsen || 0
      }

      return [
        { item: 'Sponsor', value: sponsorEinnahmen },
        { item: 'Zinsen', value: zinsenEinnahmen }
      ]
    },
    getLifetimeAusgaben: (state) => {
      let kegelbahnrepair = 0
      let kegelbahnkauf = 0
      let fahrzeugrepair = 0
      let fahrzeugkauf = 0
      let trainingslager = 0
      let spielerkaeufe = 0
      let spielergehaelter = 0

      if (state.lifetime.ausgaben) {
        // kegelbahn
        if (state.lifetime.ausgaben.kegelbahn) {
          kegelbahnrepair = state.lifetime.ausgaben.kegelbahn.repair || 0
          kegelbahnkauf = state.lifetime.ausgaben.kegelbahn.buy || 0
        }
        // fahrzeug
        if (state.lifetime.ausgaben.fahrzeug) {
          fahrzeugrepair = state.lifetime.ausgaben.fahrzeug.repair || 0
          fahrzeugkauf = state.lifetime.ausgaben.fahrzeug.buy || 0
        }
        // trainingslager
        trainingslager = state.lifetime.ausgaben.trainingslager || 0
        // spielergehälter
        spielergehaelter = state.lifetime.ausgaben.spielergehaelter || 0
        // spielerkauefe
        if (state.lifetime.ausgaben.player) {
          spielerkaeufe = state.lifetime.ausgaben.player.buy || 0
        }
      }

      return [
        { item: 'Spielergehälter', value: spielergehaelter },
        { item: 'Spielereinkäufe', value: spielerkaeufe },
        { item: 'Kegelbahnreparatur', value: kegelbahnrepair },
        { item: 'Kegelbahnkäufe', value: kegelbahnkauf },
        { item: 'Fahrzeugreparatur', value: fahrzeugrepair },
        { item: 'Fahrzeugkäufe', value: fahrzeugkauf },
        { item: 'Trainingslager', value: trainingslager }
      ]
    },
    allSaisonEinnahmen: (state, getters) => {
      let sum = 0
      try {
        const einnahmen = getters.getSaisonEinnahmen
        sum = einnahmen.map(item => item.value).reduce((prev, next) => prev + next)
      } catch (error) {
        // console.log(error)
      }
      return sum
    },
    allSaisonAusgaben: (state, getters) => {
      let sum = 0
      try {
        const ausgaben = getters.getSaisonAusgaben
        sum = ausgaben.map(item => item.value).reduce((prev, next) => prev + next)
      } catch (error) {
        // console.log(error)
      }
      return sum
    },
    allLifetimeEinnahmen: (state, getters) => {
      let sum = 0
      try {
        const einnahmen = getters.getLifetimeEinnahmen
        sum = einnahmen.map(item => item.value).reduce((prev, next) => prev + next)
      } catch (error) {
        // console.log(error)
      }
      return sum
    },
    allLifetimeAusgaben: (state, getters) => {
      let sum = 0
      try {
        const ausgaben = getters.getLifetimeAusgaben
        sum = ausgaben.map(item => item.value).reduce((prev, next) => prev + next)
      } catch (error) {
        // console.log(error)
      }
      return sum
    }
  },
  actions: {
    async saveSponsor ({ state, commit, getters, dispatch, rootState }, sponsorId) {
      // set transport options
      const transportOptions = {
        url: getters.saveSponsorURL,
        data: { sponsorid: sponsorId }
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set sponsor and money
        commit(MT.MONEY_SET_SPONSOR, response.data.sponsor)
        commit(MT.MONEY_SET_GIRO, response.data.finanzen.giro)
        // set init finished
        commit(MT.ROOT_SET_INIT, { finished: true }, { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // return all sponsors
    async getAllSponsoren ({ state, commit, getters, dispatch, rootState }) {
      // set transport options
      const transportOptions = {
        method: 'get',
        data: { fakeData: true },
        url: getters.allSponsorenUrl,
        withoutAuth: true
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        await commit(MT.MONEY_SET_ALL_SPONSOREN, response.data.sponsoren)
      } else {
        ret = false
      }

      return ret
    },
    // return all user finanzen
    async getUserFinanzen ({ state, commit, getters, dispatch, rootState }) {
      // set transport options
      const transportOptions = {
        data: { fakeData: true },
        url: getters.usersFinanzenURL
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        commit(MT.MONEY_SET_FINANZEN, response.data.finanzen)
      } else {
        ret = false
      }

      return ret
    },
    // save sparbetrag
    async saveSparbetrag ({ state, commit, getters, dispatch, rootState }, sparItem) {
      // set transport options
      const transportOptions = {
        data: sparItem,
        url: getters.saveSparbetrag
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        commit(MT.MONEY_SET_GIRO, response.data.giro)
        commit(MT.MONEY_SET_SPAR, response.data.sparItems)
      } else {
        ret = false
      }

      return ret
    }
  }
}
